import NewItemForm from "../../../Components/Items/Create/NewItemForm";

export default function New({ user }) {
  return <NewItemForm user={user} />;
}
